import { apiClient } from './client';

// ── Search Types ──

export interface SearchResultItem {
  type: 'return' | 'delivery' | 'delivery_note' | 'item';
  id: number | string;
  uid: string | null;
  title: string;
  subtitle: string | null;
  url: string;
  matched_field: string;
  created_at: string | null;
}

export interface SearchResponse {
  results: SearchResultItem[];
  query: string;
  total: number;
}

// ── Search API ──

export const searchApi = {
  search: async (q: string, limit = 5): Promise<SearchResponse> => {
    const response = await apiClient.get<SearchResponse>('/search', {
      params: { q, limit },
    });
    return response.data;
  },
};
